
import Vue from "vue";
import NovelDetailEdit from "@/components/organisms/NovelDetailEdit.vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  props: { novelId: String },
  components: { NovelDetailEdit },
});
